import { Button, ButtonProps } from '../../../shared/components/ui/button'
import { cn } from '../../../shared/lib/utils'
import React from 'react'

function ProfileUpdateButton({className, ...props}: ButtonProps) {
    return (
        <Button 
            className={cn('w-full md:w-[200px]', className)}
            {...props}
        >
            {props.children || 'Update'}
        </Button>
    )
}

export default ProfileUpdateButton